angular.module('tgaAdmin')
  .controller('GameJeopardyController', [
    '$scope', '$timeout', 'modalService', '$filter', 'placeholderDataService',
    function (
      $scope, $timeout, modalService, $filter, placeholderDataService,
    ) {
      $scope.data.questionTypes = [{
        id: 'multiple_choice',
        name: 'Multiple Choice',
      }, {
        id: 'text_input',
        name: 'Text Input',
      }];

      $scope.data.matchTypes = [{
        id: null,
        name: 'Exact',
      }, {
        id: 'contains',
        name: 'Contains',
      }, {
        id: 'starts_with',
        name: 'Starts With',
      }, {
        id: 'ends_with',
        name: 'Ends With',
      }, {
        id: 'inside',
        name: 'Inside',
      }];

      $scope.questionTooltip = $filter('translate')('game.jeopardy.question_tooltip_html');
      $scope.data.categoryTabs = [];

      $scope.accordionState = {
        question: null,
        feedback: null,
      };

      $scope.defaultQuestion = {
        isOpen: false,
        question_id: null,
        question_type: 'multiple_choice',
        question_category: null,
        text: null,
        answer_phrase: null,
        image: null,
        audio: null,
        video: null,
        points_correct: null,
        points_incorrect: null,
        response_correct: null,
        response_incorrect: null,
        response_timeout: null,
        useTimer: false,
        time: null,
        randomize_answers: true,
        show_results: null,
        skip_clue: false,
        answers: [{
          answer_id: null,
          text: null,
          image: null,
          response: null,
          correct: false,
          points: null,
        }, {
          answer_id: null,
          text: null,
          image: null,
          response: null,
          correct: false,
          points: null,
        }],
        advanced_feedback: [],
        translations: {},
        max_correct: 1,
      };

      $scope.actions.updateDefaultQuestionTimer = function () {
        $scope.defaultQuestion.useTimer = $scope.viewmodel.game.useGlobalTimer;
        $scope.defaultQuestion.time = $scope.viewmodel.game.time_per_question;
      };

      $scope.actions.changeQuestionAmount = function (group, g_index, num_questions, prev_val) {
        $scope.actions.updateDefaultQuestionTimer();
        if (group.question_groups[0].questions.length < num_questions) {
          // add more questions
          for (let i = 0; i < group.question_groups.length; i++) {
            const total_questions = num_questions - group.question_groups[i].questions.length;
            for (let j = 0; j < total_questions; j++) {
              const placeholder = placeholderDataService.setJeopardyPlaceholder(angular.copy($scope.defaultQuestion));
              group.question_groups[i].questions.push(placeholder);
            }
          }
        } else if (group.question_groups[0].questions.length > num_questions) {
          let message;
          if (group.question_groups[0].questions.length - num_questions > 1) {
            // eslint-disable-next-line max-len
            message = `Are you sure you want to remove ${String(group.question_groups[0].questions.length - num_questions)} questions from the end of each category in this round? All analytics data associated with the questions will be permanently deleted.`;
          } else {
            // eslint-disable-next-line max-len
            message = 'Are you sure you want to remove 1 question from the end of each category in this round? All analytics data associated with the questions will be permanently deleted.';
          }

          // remove questions
          modalService.showModal({
            title: 'Delete Question(s)?',
            message,
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            for (let i = 0; i < group.question_groups.length; i++) {
              group.question_groups[i].questions.splice(-(group.question_groups[i].questions.length - num_questions));
            }
          }, () => {
            group.num_questions = prev_val;
          });
        }
      };

      $scope.actions.onAnswerContentChanged = function (editor, editorContents, source, trim = false) {
        if (source === 'user') {
          const html = editor.root.innerHTML;
          const currentSelection = editor.getSelection();

          // Remove all <br> tags
          const htmlWithoutBr = html.replace(/<br\s*\/?>/gi, '');

          // Split the content into paragraphs
          let paragraphs = htmlWithoutBr.split(/<\/p>/i).filter(p => p.trim() !== '');

          // Limit to 2 paragraphs and append remaining content to the second paragraph
          if (paragraphs.length > 2) {
            const extraContent = paragraphs.slice(2).join(' ').replace(/<p>/gi, '');
            paragraphs = paragraphs.slice(0, 2);
            paragraphs[1] += ' ' + extraContent;
          }

          // Rebuild the content
          const cleanedHtml = paragraphs.map(p => trim ? p.trim() : p + '</p>').join('');

          if (html !== cleanedHtml) {
            // Use the clipboard to convert and apply changes silently
            const delta = editor.clipboard.convert(cleanedHtml);
            editor.setContents(delta, 'silent'); // Update content without triggering another change event

            // Restore the selection range
            if (currentSelection) {
              editor.setSelection(currentSelection.index, currentSelection.length, 'silent');
            }
          }
        }
      }

      $scope.actions.addCategory = function (group) {
        $scope.gameForm.$setDirty();
        const questions = [];
        $scope.actions.updateDefaultQuestionTimer();

        for (let i = 0; i < group.num_questions; i++) {
          const placeholder = placeholderDataService.setJeopardyPlaceholder(angular.copy($scope.defaultQuestion));
          placeholder.hash = placeholder.hash || uuidv4();
          questions.push(placeholder);
        }
        group.num_categories++;

        const qgNameArray = group.question_groups.map((qg) => ({ nameSplit: qg.name.split(' ') }));

        let categoryNumber = 0;
        /**
         * Determine what the next Category number should be.
         * Trying to keep consistent with user expectation
         */
        for (let i = 0; i < qgNameArray.length; i++) {
          const { nameSplit } = qgNameArray[i];
          if (nameSplit[0] === 'Category'
            && angular.isDefined(nameSplit[1])
            && !Number.isNaN(nameSplit[1])
            && angular.isUndefined(nameSplit[2])
            && parseInt(nameSplit[1], 10) > categoryNumber
          ) {
            categoryNumber = parseInt(nameSplit[1], 10);
          }
        }

        group.question_groups.push({
          name: `Category ${categoryNumber > 0 ? categoryNumber + 1 : group.num_categories}`,
          questions,
        });
      };

      $scope.actions.changeCategoryTab = function (group_index, category_index) {
        $scope.data.categoryTabs[group_index] = category_index;
      };

      $scope.actions.moveCategory = function (group_index, from, to) {
        $scope.gameForm.$setDirty();
        // eslint-disable-next-line max-len
        $scope.viewmodel.game.question_groups[group_index].question_groups.splice(to, 0, $scope.viewmodel.game.question_groups[group_index].question_groups.splice(from, 1)[0]);
        $scope.actions.changeCategoryTab(group_index, to);
      };

      $scope.actions.deleteCategory = function (group, c_index) {
        modalService.showModal({
          title: 'Delete Category?',
          message: 'Are you sure you want to remove this category. All questions and analytic data will be deleted if you continue.',
          closeButton: 'No',
          actionButton: 'Yes',
        }, {
          backdrop: true,
          keyboard: true,
          animation: false,
        }).then(() => {
          $scope.gameForm.$setDirty();
          group.question_groups.splice(c_index, 1);
          group.num_categories--;
          $scope.renameOnDefaultDelete(group.question_groups);
        }, () => { });
      };

      $scope.renameOnDefaultDelete = function (question_groups) {
        const qgNameArray = question_groups.map((qg) => ({ nameSplit: qg.name.split(' ') }));
        /**
         * if the user has shuffled the order of the categories
         * then we don't perform this renaming process.
         * */
        for (let i = 0; i < qgNameArray.length; i++) {
          const { nameSplit } = qgNameArray[i];
          if (nameSplit[0] === 'Category' && nameSplit[1] !== i + 1 && nameSplit[1] !== i + 2) {
            return;
          }
        }

        for (let i = 0; i < qgNameArray.length; i++) {
          const { nameSplit } = qgNameArray[i];
          const match = nameSplit.length === 2 && nameSplit[0] === 'Category' && nameSplit[1] === i + 2;
          if (match) {
            question_groups[i].name = `Category ${i + 1}`;
          }
        }
      };

      $scope.actions.toggleQuestionCollapse = function (g_index, c_index, q_index) {
        // toggle accordion
        const id = `${g_index}_${c_index}_${q_index}`;
        $scope.accordionState.question = id === $scope.accordionState.question ? null : id;

        $timeout(() => {
          $('html, body').stop(true, false).animate({
            scrollTop: $('#parent-group').children('.panel').eq(g_index).find('.category-group')
              .eq(c_index)
              .find('.panel')
              .filter(function () {
                return !$(this).parentsUntil('.category-group', '.panel').length;
              })
              .eq(q_index)
              .offset().top - 120,
          }, 250);
        }, 10);
      };

      $scope.questionAccordionIsActive = function (g_index, c_index, q_index) {
        return $scope.accordionState.question === `${g_index}_${c_index}_${q_index}`;
      };

      $scope.actions.toggleFeedbackCollapse = function (g_index, c_index, q_index, f_index) {
        // toggle accordion
        const id = `${g_index}_${c_index}_${q_index}_${f_index}`;
        $scope.accordionState.feedback = id === $scope.accordionState.feedback ? null : id;
        $timeout(() => {
          $('html, body').stop(true, false).animate({
            scrollTop: $('#parent-group').children('.panel').eq(g_index).find('.category-group')
              .eq(c_index)
              .find('.panel')
              .eq(q_index)
              .find('.panel')
              .eq(f_index)
              .offset().top - 120,
          }, 250);
        }, 10);
      };

      $scope.feedbackAccordionIsActive = function (g_index, c_index, q_index, f_index) {
        return $scope.accordionState.feedback === `${g_index}_${c_index}_${q_index}_${f_index}`;
      };

      $scope.actions.verifyQuestionGroups = function () {
        $scope.actions.submit(true);
      };
      // need this to fill out timers of question group questions on load
      $scope.actions.setLastGlobalTimePerQuestion();
      $scope.actions.changeGlobalTimePerQuestion();
    }]);
